import { render, staticRenderFns } from "./CreaNivelDos.vue?vue&type=template&id=2dee4611"
import script from "./CreaNivelDos.vue?vue&type=script&lang=js"
export * from "./CreaNivelDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports